module.exports = __webpack_public_path__ + "static/media/alpine_shine_logo.80c72a09.jpg";